import React from "react";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";
import LeaveBalanceCard from "@/components/LeaveBalanceCard";
import LeaveYearStrip from "@/components/LeaveYearStrip";

/**
 * Iter-38: dedicated leaves page reachable from the Work group in the sidebar
 * (between Timesheet and Stats). Hidden from freelance profiles.
 */
export default function Conges() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.is_freelance) return <Navigate to="/dashboard" replace />;
  const year = new Date().getFullYear();
  return (
    <div className="p-4 md:p-8 lg:p-12 max-w-[1400px]" data-testid="conges-page">
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-3 font-mono">Work · Leaves</div>
        <h1 className="font-heading text-2xl md:text-4xl font-bold tracking-tight">My leaves {year}</h1>
        <p className="text-zinc-500 mt-3 max-w-2xl">
          Leave tracking for the year: remaining quota, carry-over credit and monthly timeline.
          Leaves are booked from the timesheet — click 'Open timesheet' to go there.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-6">
        <LeaveBalanceCard />
        <LeaveYearStrip alwaysVisible />
      </div>
    </div>
  );
}
